// Project: domainSlice.ts
// File Path: src/redux/slices/domainSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DomainState {
  mainDomain: string | null,
  isValidMainDomain: boolean,

  subDomain: string | null,
  isValidSubDomain: boolean,

  customDomain: string | null,
  isValidCustomDomain: boolean,

  // 'main' | 'sub' | 'custom'
  domainType: 'main' | 'sub' | 'custom' | null,
  domain : string | null
  // null if not set
}

const initialState: DomainState = {
  mainDomain: null,
  isValidMainDomain: false,

  subDomain: null,
  isValidSubDomain: false,

  customDomain: null,
  isValidCustomDomain: false,

  domainType: null,
  domain: null
}

const domainSlice = createSlice({
  name: 'domain',
  initialState,
  reducers: {
    // Setters for main domain
    setMainDomain: (state, action: PayloadAction<string | null>) => {
      state.mainDomain = action.payload
    },
    setIsValidMainDomain: (state, action: PayloadAction<boolean | false>) => {
      state.isValidMainDomain = action.payload
    },

    // Setters for sub domain
    setSubdomain: (state, action: PayloadAction<string | null>) => {
      state.subDomain = action.payload
    },
    setIsValidSubDomain: (state, action: PayloadAction<boolean | false>) => {
      state.isValidSubDomain = action.payload
    },

    // Setters for custom domain
    setCustomDomain: (state, action: PayloadAction<string | null>) => {
      state.customDomain = action.payload
    },
    setIsValidCustomDomain: (state, action: PayloadAction<boolean | false>) => {
      state.isValidCustomDomain = action.payload
    },
    setDomainType: (state, action: PayloadAction<'main' | 'sub' | 'custom' | null>) => {
      state.domainType = action.payload
    },
    setDomain: (state, action: PayloadAction<string | null>) => {
        state.domain = action.payload
      },
  },
})

export const {
  setMainDomain,
  setIsValidMainDomain,
  setSubdomain,
  setIsValidSubDomain,
  setCustomDomain,
  setIsValidCustomDomain,
  setDomainType,
  setDomain
} = domainSlice.actions

export default domainSlice.reducer
